import React, {useContext, useState, useEffect} from 'react';

import {AuthContext} from '../../context';
import {modifyPassword} from '../../api';
import {unauthorized} from '../../utils';
import {Button, Input, Notification, PageContainer, Section} from '../../components';

const DashboardAdmin = ({history}) => {
  const {user} = useContext(AuthContext);
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notif, setNotif] = useState('');

  const modifyPasswordHandler = async (e) => {
    e.preventDefault();
    setNotif();

    if (password !== confirmPassword) {
      setTimeout(() => {
        setNotif('');
      }, 2000);
      return setNotif({type: 'error', text: 'Les mots de passe de correspondent pas.'});
    }

    const {data, error} = await modifyPassword(user.infos._id, oldPassword, password);
    await unauthorized(error, history);
    if (error) return setNotif({type: 'error', text: error});
    setNotif({type: 'success', text: data});
    setOldPassword('');
    setPassword('');
    setConfirmPassword('');
  };

  const handleDisabled = () => {
    if (
      oldPassword.length === 0 ||
      password.length === 0 ||
      confirmPassword.length === 0
    ) {
      return true;
    }
  };

  useEffect(() => {
    if (history.location.state)
      return setNotif({type: 'success', text: history.location.state});
  }, []);

  return (
    <PageContainer role={user.infos.role} companyName="Sublissime" title="Mon compte">
      <Section title="Profil">
        <div className="modify-password-form">
          <Input
            label="Email"
            type="email"
            name="email"
            value={user.infos.email}
            readOnly
            dark
          />
        </div>
      </Section>
      <Section title="Sécurité">
        <form onSubmit={modifyPasswordHandler} className="modify-password-form">
          <div>
            <Input
              label="Votre ancien mot de passe"
              type="password"
              name="oldPassword"
              value={oldPassword}
              handleChange={(e) => setOldPassword(e.target.value)}
              required
              dark
            />
            <Input
              label="Votre nouveau mot de passe"
              type="password"
              name="password"
              value={password}
              handleChange={(e) => setPassword(e.target.value)}
              required
              dark
            />
            <Input
              label="Confirmez votre nouveau mot de passe"
              type="password"
              name="confirmPassword"
              value={confirmPassword}
              handleChange={(e) => setConfirmPassword(e.target.value)}
              required
              dark
            />
          </div>
          <Button type="submit" label="Modifier" light disabled={handleDisabled()} />
        </form>
      </Section>
      {notif && <Notification type={notif.type} text={notif.text} />}
    </PageContainer>
  );
};

export default DashboardAdmin;
